import fmpLogo from '../../../../../assets/fmp_logo.png'

export default function DashboardFMPMailingList() {
  return (
    <div className='w-1/3 max-sm:w-full rounded-2xl bg-white shadow-md flex flex-col gap-4 text-ertc-secondary'>
      <div className='flex items-center justify-center pb-2 bg-ertc-secondary w-full rounded-t-2xl'>
        <img className='w-2/3' src={fmpLogo} alt='FMP Logo' />
      </div>
      <div className='h-full pl-4 pr-4 pb-4 flex flex-col gap-4'>
        <p className='font-bold'>Helping People Find <span className='text-yellow-500'>Tax Credits</span> Today</p>
        <p>The Found Money Project is dedicated to helping people collect money that would otherwise go unclaimed. And when you know where to look, you'd be surpised how much you find.</p>
        <button className='w-1/2 py-2 rounded-lg bg-ertc-secondary text-white font-bold text-xl self-center mt-auto'>
          Join Our Mailing List
        </button>
      </div>
    </div>
  )
}